<template>
    <div class="min-h-screen w-full pt-24 overflow-x-hidden">
        <div class="flex flex-col md:flex-row items-center justify-between px-6 max-w-7xl mx-auto">
            <div class="text-center flex flex-col justify-between md:text-left">
                <h1 class="text-6xl md:text-7xl text-gray-800 font-bold mt-12">
                    Hire Now, Pay
                    <span class="relative inline-block whitespace-nowrap">
                        <div class="absolute inset-0 -rotate-2 bg-yellow-400 -z-10"></div>
                        Later.
                    </span>
                </h1>
                <p class="text-gray-600 my-8 text-lg w-full md:w-3/4">Sed placerat convallis aenean fermentum. Aliquet eget feugiat sed consectetur sodales eleifend.</p>
                <div class="my-8">
                    <router-link to="/request-service" class="text-white font-bold bg-NeonBlue px-6 py-4 rounded-lg hover:opacity-85 transition-all"> Hire Top AI and Software Developers </router-link>
                </div>
            </div>
            <div class="mt-8 md:mt-0">
                <img src="@/assets/landing-page-logos/bpo.svg" alt="image" class="max-w-full md:max-w-lg" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "OutSourceBanner",
};
</script>
